import Enums from '@core/types/api/Enums';
import { isValidUUID } from '@core/utils/uuid';

import { useSlabQuery } from './useSlabQuery';

/** Counts the location's active products, minus the excluded ones; undefined until loaded. */
export const useLocationProductsLeft = (
  plantId: string,
  excludedProductIds: string[],
): { count: number | undefined; isLoading: boolean } => {
  const { data, isLoading } = useSlabQuery(
    'GET products',
    {
      queryParams: {
        perPage: 1,
        page: 0,
        filterBy: [
          {
            name: 'plantId',
            operation: Enums.FilterOperation.Equals,
            values: [plantId],
          },
          {
            name: 'isArchived',
            operation: Enums.FilterOperation.Equals,
            values: [false],
          },
          ...(excludedProductIds.length > 0
            ? [
                {
                  name: 'id' as const,
                  operation: Enums.FilterOperation.NotEquals,
                  values: excludedProductIds,
                },
              ]
            : []),
        ],
      },
    },
    {
      enabled: isValidUUID(plantId),
    },
  );

  return { count: data?.count, isLoading };
};
